import React from 'react';
import {
  HeadingText,
  BodyText,
  Accordion,
  AccordionRow,
  Link,
} from '@paypalcorp/pp-react';
import { Message } from '@paypalcorp/worldready-react';

const getFaqContent = () => {
  const path = 'buttonsV3.login.';
  return [
    {
      question: <Message id={`${path}faq.questions.group1.question`} />,
      answer: (
        <Message
          id={`${path}wr.faq.questions.group1.answer`}
          link={(innerMessage) => (
            <Link href="/bizsignup" target="_blank">
              {innerMessage}
            </Link>
          )}
        />
      ),
    },
    {
      question: <Message id={`${path}faq.questions.group2.question`} />,
      answer: (
        <Message
          id={`${path}wr.faq.questions.group2.answer`}
          link={(innerMessage) => (
            <Link
              href="/webapps/mpp/merchant-fees#ReceivingDonations"
              target="_blank"
            >
              {innerMessage}
            </Link>
          )}
          consumerLink={(innerMessage) => (
            <Link
              href="/webapps/mpp/paypal-fees#ReceivingDonations"
              target="_blank"
            >
              {innerMessage}
            </Link>
          )}
          merchantLink={(innerMessage) => (
            <Link
              href="/webapps/mpp/merchant-fees#ReceivingDonations"
              target="_blank"
            >
              {innerMessage}
            </Link>
          )}
        />
      ),
    },
  ];
};

const Faq = () => {
  return (
    <div className="login-faq-container">
      <HeadingText size="lg" className="login-faq-title">
        <Message id="buttonsV3.login.faq.title" />
      </HeadingText>
      <div className="faq-questions">
        <Accordion name="bf-login-faq">
          {getFaqContent().map((row, index) => (
            <AccordionRow
              isOpen="true"
              heading={
                <HeadingText size="sm" className="faq-heading-text">
                  {row.question}
                </HeadingText>
              }
              key={index}
            >
              <BodyText>
                <div className="faq-row-content">{row.answer}</div>
              </BodyText>
            </AccordionRow>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default Faq;
